import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../css/Service.css";

const services = [
  {
    title: "Dedicated KAM Support",
    desc: "Partner with us to unlock the power of providing exceptional Key Account Managers for your customers, tailored to meet your unique business needs.",
    img: "/services/65338efd7a9bc84b73f26432_Service 24_7-pana.svg",
  },
  {
    title: "Email & Chat Support",
    desc: "Your customers will love quick and reliable solutions with a tap on their phones. Our dedicated team is always ready to assist them in real-time.",
    img: "/services/65338efd7a9bc84b73f26428_Conversation-pana.svg",
  },
  {
    title: "Technical Support",
    desc: "Uninterrupted business operations are just a call away with our technical support solutions. Experience hassle-free IT operations.",
    img: "/services/65338efd7a9bc84b73f2642b_Active Support-cuate.svg",
  },
  {
    title: "Pre-Sales",
    desc: "Let us assist you in navigating the presale process and securing more sales for your business. Convert prospects into loyal customers.",
    img: "/services/65338efd7a9bc84b73f2642d_Consultative sales-pana.svg",
  },
  {
    title: "Backend Operations",
    desc: "Say goodbye to backend hassles and hello to seamless operations with our backend support solutions.",
    img: "/services/65338efd7a9bc84b73f2642c_Operating system-rafiki.svg",
  },
  {
    title: "Customer Retention",
    desc: "Keep your customers coming back for more with our expert customer retention strategies. Achieve sustainable business growth.",
    img: "/services/65338efd7a9bc84b73f26427_Generating new leads-pana.svg",
  },
  {
    title: "Lead Generation",
    desc: "We can turn up your fresh and abandoned database into Happy Customers.",
    img: "/services/65338efd7a9bc84b73f2642e_Sentiment analysis-rafiki.svg",
  },
  {
    title: "Telemarketing Support",
    desc: "Let our expert telemarketing team take your business to the next level with personalized outreach strategies.",
    img: "/services/65338efd7a9bc84b73f2642f_Call center-bro.svg",
  },
  {
    title: "Back Office Work",
    desc: "Our back-office solutions are designed to streamline your business operations and improve efficiency.",
    img: "/services/65338efd7a9bc84b73f26430_Shared workspace-bro.svg",
  },
  {
    title: "Inbound Customer Support",
    desc: "Get real-time assistance and personalized solutions with our 24/7 inbound call center support",
    img: "/services/65338efd7a9bc84b73f2642a_Contact us-pana.svg",
  },
  {
    title: "Outbound Services",
    desc: "Experience increased ROI and greater customer engagement with our expert outbound call center services.",
    img: "/services/65338efd7a9bc84b73f26431_Active Support-bro.svg",
  },
];

const Service = () => {
  return (
    <section className="service-section">
      <Container>
        {/* Heading */}
        <div className="text-center mb-5">
          <small className="text-primary fw-semibold">What we offer</small>
          <h2 className="fw-bold mt-2">Our Services</h2>
          <p className="text-muted mt-2">
            Trusted by over 22+ prestigious corporations in India for backend
            office work and customer support.
          </p>
        </div>

        {/* Service Cards */}
        <Row>
          {services.map((item, index) => (
            <Col lg={3} md={4} sm={6} className="mb-4" key={index}>
              <Card className="service-card h-100">
                <Card.Img
                  variant="top"
                  src={item.img}
                  className="service-img"
                />
                <Card.Body>
                  <Card.Title>{item.title}</Card.Title>
                  <Card.Text>{item.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Buttons */}
        <div className="text-center mt-4">
          <Button variant="outline-secondary" className="me-3">
            Read FAQs
          </Button>
          <Button variant="primary">Contact Us</Button>
        </div>
      </Container>
    </section>
  );
};

export default Service;
